// The DJ's own song tags (ITER-073), keyed like songLinks — written by the DJ's browser, never shared

import { collection, deleteDoc, doc, getDocs, serverTimestamp, setDoc, type DocumentData } from 'firebase/firestore';
import { db } from './firebase';
import { isValidSongLinkKey } from '../utils/songLinks';

export interface SongTagDoc {
  songKey: string;
  tags: string[];
  updatedAt: string | null;
}

function isoOrNull(value: unknown): string | null {
  if (value && typeof (value as { toDate?: unknown }).toDate === 'function') {
    return (value as { toDate: () => Date }).toDate().toISOString();
  }
  return typeof value === 'string' ? value : null;
}

export function docToSongTags(id: string, data: DocumentData): SongTagDoc | null {
  if (!Array.isArray(data.tags) || !data.tags.every((tag: unknown) => typeof tag === 'string')) return null;
  return { songKey: id, tags: data.tags, updatedAt: isoOrNull(data.updatedAt) };
}

export async function getMySongTags(djUid: string): Promise<Map<string, string[]>> {
  const snap = await getDocs(collection(db, 'users', djUid, 'songTags'));
  const tagsBySong = new Map<string, string[]>();
  for (const snapshot of snap.docs) {
    const songTags = docToSongTags(snapshot.id, snapshot.data());
    if (songTags === null) {
      console.warn(`[songTags] Skipping song tags doc with malformed tags: ${snapshot.id}`);
      continue;
    }
    tagsBySong.set(songTags.songKey, songTags.tags);
  }
  return tagsBySong;
}

export async function setSongTags(djUid: string, songKey: string, tags: string[]): Promise<void> {
  if (!isValidSongLinkKey(songKey)) throw new Error(`Invalid song key: ${songKey}`);
  const ref = doc(db, 'users', djUid, 'songTags', songKey);
  if (tags.length === 0) {
    await deleteDoc(ref);
    return;
  }
  await setDoc(ref, { songKey, tags, updatedAt: serverTimestamp() });
}
